import * as React from "react";
import { Helmet } from "react-helmet";
import { connect } from "common/connect";
import StoreKeys from "common/storeKeys";
import { GetCurrentGameDisplayName } from "common/constants/Games";

const propKeys = {
	eventData: StoreKeys.EVENT.EVENTDATA,
};

function EventPageTitleC({ eventData }) {
	const name =
		eventData?.nameOverride ||
		eventData?.name ||
		GetCurrentGameDisplayName();
	return (
		<Helmet>
			<title>{`${name} Pick'em | Pickstop`}</title>
		</Helmet>
	);
}

export default function EventPageTitle(props) {
	return connect(<EventPageTitleC />, propKeys, props);
}
